module.exports = __webpack_public_path__ + "img/820_1.44955543.png";